import template from './index.html'
import { FileUploadSingleController } from './controller'

config.vsNgType = 'factory'

config.$inject = ['formlyConfigProvider']
function config(formlyConfigProvider) {
  var type = {
    name: 'fileUploadSingle',
    templateUrl: template,
    controller: FileUploadSingleController,
    wrapper: ['bootstrapLabel', 'bootstrapHasError'],
    defaultOptions: {
      templateOptions: {
        required: false
      },
    }
  }

  formlyConfigProvider.setType(type)
}

export default config
